import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { ProductInventory } from '@domain/inventory/models/Inventory';
import { PaginatedResource } from '@domain/base/Resource';
import { InventoryFilter } from '@domain/inventory/models/InventoryFilter';


export const useInventory = (filter?: InventoryFilter) => {
  const {
    data: inventoryResponse,
    isLoading: isLoadingInventory,
    isFetching: isFetchingInventory,
  } = useQuery<PaginatedResource<ProductInventory[]>>({
    queryKey: ['inventory', filter],
    queryFn: async () => {
      const result = await container.inventoryRepository.getInventory(filter);
      if (result.status === 'error') throw new Error(result.error.message);
      return result;
    },
    enabled: true,
    refetchOnWindowFocus: false,
  });


  return {
    inventory: inventoryResponse,
    isLoading: isLoadingInventory,
    isFetching: isFetchingInventory,
  };
};

export const useProductInventory = (id?: string, enabled = true) => {
  const {
    data: inventory,
    isLoading: isLoadingInventory,
    error
  } = useQuery<ProductInventory>({
    queryKey: ['inventory', id],
    queryFn: async () => {
      const result = await container.inventoryRepository.getInventoryByProductId(id!);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
    enabled: Boolean(id) && enabled,
  });


  return {
    inventory,
    isLoading: isLoadingInventory,
    error
  };
}; 